/* Así funciona · Luces Navideñas Solares 600 LED (2258482)
   Fotos reales del producto encendido (amarilla cálida y multicolor) y la MISMA foto con los leds apagados (mismos
   píxeles sin el brillo). De día el panel solar real se carga con el sol (un reflejo de luz pasa por su vidrio); al
   deslizar hacia la noche el cuarto se oscurece y las luces se prenden solas (lo dice la ficha: se cargan con el sol
   y se activan al oscurecer). Los 8 modos prenden y apagan cada led real desde su posición real (motor WebGL
   NHF.fx.luces). Piezas: tiendas/nayhogar/funciona/luces-navidenas-solares-600-led/hacer.py */
NHF.escena('luces-navidenas-solares-600-led', function (E) {
  const D = /*DATOS*/{"caja":[150,100,1200,1200],"panel":[[1110,185],[1385,205],[1330,520],[1055,478]],"colores":{"amarillo":{"on":"fn-luces-navidenas-solares-600-led-amarillo-on.webp","off":"fn-luces-navidenas-solares-600-led-amarillo-off.webp","mapa":"fn-luces-navidenas-solares-600-led-amarillo-mapa.webp","halo":"fn-luces-navidenas-solares-600-led-amarillo-halo.webp","leds":687},"multicolor":{"on":"fn-luces-navidenas-solares-600-led-multicolor-on.webp","off":"fn-luces-navidenas-solares-600-led-multicolor-off.webp","mapa":"fn-luces-navidenas-solares-600-led-multicolor-mapa.webp","halo":"fn-luces-navidenas-solares-600-led-multicolor-halo.webp","leds":382}}}/*FIN*/;
  const R = D.caja;
  const S = E.lienzo({ w: 1600, h: 1600, vista: R });
  E.titulo('De día se cargan, [de noche brillan].', 'Desliza hacia la noche: se prenden solas. Después prueba sus 8 modos de luz.');
  E.conSonido();
  S.cargando(true);
  const fondo = S.img(D.colores.amarillo.off, R, { z: 1, alt: 'Luces navideñas solares de 600 LED con panel solar' });
  const brillo = S.canvas(R, { z: 3, res: 0.6 });
  let L = null, color = 'amarillo', noche = 0, modo = 0, auto = false, imgs = {};
  const cargarColor = c => E.cargar([D.colores[c].on, D.colores[c].off, D.colores[c].mapa, D.colores[c].halo]).then(r => { imgs[c] = r; return r; });

  /* ---------- panel ---------- */
  E.pasos(['Desliza hacia la noche', 'Prueba los 8 modos de luz', 'Cambia el color de la luz']);
  E.paso(0);
  const rango = E.deslizador({ etiqueta: 'Hora del día', min: 0, max: 100, valor: 0, formato: v => v < 25 ? 'Mediodía' : v < 55 ? 'Atardecer' : v < 80 ? 'Noche' : 'Medianoche' }, v => ponerNoche(v / 100));
  const top = E.el('div', 'lu-modos'); top.style.cssText = 'display:grid;gap:10px;width:100%'; E.ctrls.appendChild(top);
  const etq = E.el('span', 'nhf-rango__t', '8 modos de luz'); top.appendChild(etq);
  const segModo = E.seg([1, 2, 3, 4, 5, 6, 7, 8].map((n, i) => ({ id: i, texto: String(n) })), m => { modo = m; if (L) L.m = m; E.sonido.clic(); vistos.add(m); guia(); }, { etiqueta: 'Modo de luz', en: top });
  const segColor = E.seg([{ id: 'amarillo', texto: 'Amarilla cálida', color: '#FFC46B' }, { id: 'multicolor', texto: 'Multicolor', color: 'conic-gradient(#ff6b6b,#ffd36b,#6bff9e,#6bc8ff,#b06bff,#ff6b6b)' }],
    c => ponerColor(c, true), { etiqueta: 'Color de la luz' });
  const lect = E.lectura({ etiqueta: 'Luces' }); lect.poner('Cargando con el sol');
  lect.querySelector('.nhf-lectura__v').style.fontSize = 'clamp(26px,3vw,38px)';
  E.nota('600 LED · panel solar · resisten la lluvia (IP65).');
  const vistos = new Set([0]);

  function ponerNoche(k) {
    noche = k; S.el.classList.add('is-tocado');
    E.noche(k > 0.5);
    const on = k >= 0.55;
    if (on !== auto) { auto = on; if (on) { E.sonido.tono(1300, .06, .02); } }
    lect.poner(on ? 'Encendidas solas' : (k > 0.35 ? 'Ya casi…' : 'Cargando con el sol'));
    guia();
  }
  function ponerColor(c, desdeEscena) {
    if (c === color && L) return;
    color = c; segColor.elegir(c);
    (imgs[c] ? Promise.resolve(imgs[c]) : cargarColor(c)).then(r => {
      fondo.src = E.archivo(D.colores[c].off);
      if (L) L.texturas(r[0], r[1], r[2], r[3]);
    });
    if (c === 'multicolor' && noche < 0.6) { rango.poner(80); ponerNoche(0.8); } // la foto multicolor es de noche
    if (desdeEscena) { // la misma opción en la compra
      const p = E.producto, i = (p.opciones || []).findIndex(o => /color/i.test(o));
      if (i >= 0) E.seleccionar(i, c === 'amarillo' ? 'Amarillo' : 'Multicolor');
      vistoColor = true; guia();
    }
  }
  let vistoColor = false;
  E.alCambiarVariante(v => { const t = (v.title || '').toLowerCase(); if (/multi/.test(t)) ponerColor('multicolor'); else if (/amar/.test(t)) ponerColor('amarillo'); });
  function guia() {
    let p = 0, pista = 'Desliza la barra hacia la noche';
    if (auto) { p = 1; pista = 'Toca los modos del 1 al 8'; }
    if (auto && vistos.size >= 3) { p = 2; pista = 'Prueba la luz multicolor'; }
    if (auto && vistos.size >= 3 && vistoColor) { p = 3; pista = ''; }
    E.paso(p); S.pista(pista || null, p === 0 ? 'flechas' : 'toca');
    if (p === 3) E.listo('Sin enchufes: el sol las carga de día y de noche se prenden solas.', reiniciar);
  }
  function reiniciar() { E.noListo(); vistos.clear(); vistos.add(0); vistoColor = false; modo = 0; segModo.elegir(0); if (L) L.m = 0; rango.poner(0); ponerNoche(0); ponerColor('amarillo'); }

  /* ---------- luces reales (WebGL) + reflejo del sol en el panel ---------- */
  let E2 = 0, t0 = 0;
  E.alVer(() => {
    cargarColor('amarillo').then(r => {
      L = E.fx.luces(S, { caja: R, on: r[0], off: r[1], mapa: r[2], halo: r[3], z: 2 });
      S.cargando(false);
      if (!L) { fondo.src = E.archivo(D.colores.amarillo.on); } // sin WebGL: la foto encendida tal cual
      E.bucle((t, dt) => {
        const meta = auto ? 1 : 0;
        E2 += (meta - E2) * Math.min(1, dt * 2.2);
        if (L) { L.n = Math.min(1, noche * 1.15); L.e = E2; L.m = modo; L.pintar(t); }
        brillo.limpiar();
        if (noche < 0.45) { // de día: el sol pasa por el vidrio del panel (se está cargando)
          const k = ((t - t0) % 3.2) / 3.2;
          E.fx.destello(brillo, { caja: [1040, 170, 360, 360], poligono: D.panel, k, alfa: 0.4 * (1 - noche / 0.45), ancho: .18 });
        }
      });
    });
  }, 0.05);
  S.pista('Desliza la barra hacia la noche', 'flechas');
});
